import { Button } from '@mantine/core'
import { useTranslation } from 'react-i18next'
import microsoftLogo from '../assets/microsoft-logo.svg'

export default function MicrosoftSignInButton(props) {
  const { t } = useTranslation()
  // Mantine draws the loader in the filled button colour (white), which vanishes on this white button.
  return <Button loaderProps={{ color: '#5E5E5E', type: 'dots' }} {...props} className="microsoft-sign-in-button" leftSection={<img src={microsoftLogo} width={21} height={21} alt="" aria-hidden="true"/>}>{t("Aanmelden met Microsoft")}</Button>
}
